export default "__VITE_ASSET__BP5LMtmP__"